export default __webpack_public_path__ + "static/media/hht2_ep08_timeline_q03_a.9071a27e.png";